module.exports = __webpack_public_path__ + "e9c477e8/img/comment-icon.2a1812af.svg";